import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom"; 
import { createBrowserHistory } from 'history';
import ROUTES from './routes';
import Header from '../components/common/Header'
const history = createBrowserHistory();

class Router extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg : '',
            steps : 0
    };
    
      }
 triggerPage = (steps = 0) => {
   this.setState({steps})
}

triggerErrorMsg = (errorMsg = '') => {
    this.setState({errorMsg})
 }
      render() {
        return (
            <>
            <Header pageStep = {this.state.steps} triggerPage = {this.triggerPage} triggerErrorMsg = {this.triggerErrorMsg} msgError = {this.state.errorMsg}>
                <BrowserRouter history={history}>
                    <Routes>
                        {ROUTES.map(obj => (
                            <Route exact={obj.exact} path={obj.path} key={obj.path} element={obj.pageElement({triggerPage : this.triggerPage, steps: this.state.steps, history, msgError: this.state.errorMsg, triggerErrorMsg : this.triggerErrorMsg})} />
                        ))}
                    </Routes>
                </BrowserRouter>
            </Header>
            </>
        );
    }
}

export default Router;
